/* src/app/shared/ui-kit/pa-table/components/pa-table-group-row/pa-table-group-row.component.scss */
.pa-table-group-row {
  padding: 0;
  background-color: var(--p-datatable-row-background);
  cursor: pointer;
}
.pa-table-group-row__content {
  display: flex;
  align-items: flex-start;
  gap: 28px;
}
.pa-table-group-row__icon {
  font-size: 14px;
  margin-left: 3px;
  margin-top: 12px;
  color: var(--secondary-subtle-inverse);
  flex-shrink: 0;
}
.pa-table-group-row__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.pa-table-group-row__title {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: var(--text-default);
}
.pa-table-group-row__subtitle {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: var(--text-default);
}
/*# sourceMappingURL=pa-table-group-row.component.css.map */
